import logger from '../utils/rbmc.logger';
import spinner from '../utils/rbmc.spinner';
import urlUtils from '../utils/rbmc.url-utils';
import cartTracking from '../tracking/rbmc.tracking.cart';
import consumerEvents from '../events/rbmc.events.consumer-events';

const selectQuantity = {
    buildSelectMenu() {
        let quantitySelector = $('.js-selectQuantity');
        quantitySelector.selectpicker({
            style:      'btn-select',
            dropupAuto: false
        }).on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
            let $this         = $(this);
            let selectedValue = $this.find('option').eq(clickedIndex).text();
            let entryNumber   = $this.data('entry-number');

            logger.log(`selectedValue: ${selectedValue} previousValue: ${previousValue}`);
            spinner.spinnerVisibility(true);
            $.post(`${urlUtils.getBaseUrl()}cart/updateCartItem/${entryNumber}/${selectedValue}`)
             .done(function (data) {
                 if (data.success) {
                     const difference = data.productQuantity - previousValue;
                     // something was added to cart
                     if (difference !== 0) {
                         //track consumer event
                         consumerEvents.trackUpdateCartEvent(data.trackingProductData, previousValue, selectedValue);
                         //track GTM dataLayer
                         if (difference > 0) {
                             cartTracking.addToCart(data.gtmProductData, difference);
                         } else {
                             cartTracking.removeFromCart(data.gtmProductData, Math.abs(difference));
                         }
                     }

                     //lower number of items added due to stock level
                     if(difference !== (selectedValue - previousValue)) {
                        logger.error('Low on stock: failed to add the required amount');
                        if(window.location.href.includes('stockerror')) {
                            window.location.reload();
                        } else {
                            window.location.href = `${window.location.href}?stockerror=true&entry=${entryNumber}`;
                        }
                        return;
                     }

                     logger.log('Success updating item quantity');
                     setTimeout(() => {
                        let url = new URL(window.location.href)
                        url.searchParams.delete('stockerror');
                        url.searchParams.delete('entry');
                        window.location.href = url.href;
                        }, 250);
                 } else {
                     logger.error('Failed to update item quantity');
                     window.location.reload();
                 }
             }).fail(function (x, e) {
                logger.error('Updating item quantity failed');
             }).always(function () {
                spinner.spinnerVisibility(false);
             });
        });
    }
};

$(() => {
    selectQuantity.buildSelectMenu();
});
